import React, { memo } from 'react';

import { IProduto } from '../../../shared/services/api/permissoes/PermissoesService';
import { Box, Typography } from '@gvdasa/react-components';

export interface IContagemDeFiltrosProps {
  lista: IProduto[]
}

export const ContagemDeFiltros: React.FC<IContagemDeFiltrosProps> = memo(({ lista }) => {

  return (
    <Box
      display={lista.length <= 0 ? 'none' : 'flex'}
      border={lista.length <= 0 ? 'none' : '1px solid #018781'}
      alignContent="center"
      borderRadius={1}
      px="0.6rem"
      textAlign="center"
    >
      <Typography
        color='#018781'
        fontSize={13}
        fontWeight={600}
        textAlign="center"
        padding='0px'
        alignSelf="center"
      >{lista.length >0 ? lista.length.toString() : ''}</Typography>
    </Box>
  )
})

